import React from 'react';
import { CaretLeftIcon } from '../../../../icon/icons/caret-left';
import { CaretRightIcon } from '../../../../icon/icons/caret-right';
import { IconButton } from '../../../icon-button/icon-button.component';
import { CalendarContainer } from '../../atoms/calendar-container';
import { CalendarControl } from '../../atoms/calendar-controls';
import { CalendarMonth } from '../../atoms/calendar-month';
import { CalendarMonths } from '../../atoms/calendar-months';
import { CalendarTitle } from '../../atoms/calendar-title';
import { CalendarWeekHeader } from '../../atoms/calendar-week-header';
import { CalendarYears } from '../../atoms/calendar-years';
import { useCalendarState } from '../../provider/calendar.provider';
import { SELECT_BY_MAP } from '../../provider/use-calendar';
import { CalendarCommonStyles } from '../common-styles';
import { CalendarControlsStyles } from './styles';

export const DialogCalendarDisplay = () => {
  const { months, selectBy } = useCalendarState();
  const { month, year, weeks } = months[0]!;
  const calWeekHeaderStyle = CalendarCommonStyles.calWeekHeaderStyles({
    fontWeight: 'bold',
  });
  const calContainerStyle = CalendarCommonStyles.calContainerStyles();
  const calContainerVars = CalendarCommonStyles.calContainerVars();
  const controlsHeader = CalendarControlsStyles.controlsHeader;
  const monthName = CalendarControlsStyles.monthName;
  const calendarControls = CalendarControlsStyles.calendarControls;

  return (
    <CalendarContainer className={calContainerStyle} style={calContainerVars}>
      <header className={controlsHeader}>
        <CalendarControl
          renderPrevButton={(props) => (
            <IconButton label={`Previous ${SELECT_BY_MAP[selectBy]}`} showLabelOnHover type='button' {...props}>
              <CaretLeftIcon color='light' />
            </IconButton>
          )}
          renderNextButton={(props) => (
            <IconButton label={`Next ${SELECT_BY_MAP[selectBy]}`} showLabelOnHover type='button' {...props}>
              <CaretRightIcon color='light' />
            </IconButton>
          )}
          className={calendarControls}
        >
          <CalendarTitle month={month} year={year} className={monthName} />
        </CalendarControl>
      </header>
      {selectBy === 'day' && (
        <React.Fragment>
          <CalendarWeekHeader className={calWeekHeaderStyle} />
          <CalendarMonth weeks={weeks} />
        </React.Fragment>
      )}
      {selectBy === 'month' && <CalendarMonths month={month} year={year} />}
      {selectBy === 'year' && <CalendarYears year={year} />}
    </CalendarContainer>
  );
};
